export default __webpack_public_path__ + "static/media/NB.da754ae4.svg";